module.exports = __webpack_public_path__ + "img/6 - 6.b583af76.png";